"use strict";

import {
    default as React,
    Component,
 } from 'react';
import PropTypes from 'prop-types';

import {
    XAxis,
    YAxis,
    XGrid,
    YGrid,
    Legend,
    scale
} from 'kaidoo-chart/core';

import {
    BarHorizontal,
    Chart
} from 'kaidoo-chart/shape';

import {horizontalProps} from './commonProps';

export default class BarHorizontalChart extends Component {

    constructor(props) {
        super(props);
    }

    static defaultProps = {
        onMouseOver: () => {},
        onMouseOut: () => {},
        ...horizontalProps
    };

    static propTypes = {
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
        margins: PropTypes.object.isRequired,
        data: PropTypes.array.isRequired,
        dataSeriesConfig: PropTypes.array.isRequired,
        xScaleSetConfig: PropTypes.array.isRequired,
        yScaleSetConfig: PropTypes.array.isRequired,
        bandScaleConfig: PropTypes.object,
        legendConfig: PropTypes.object.isRequired,
    };

    render() {
        const {
            xScaleSetConfig,
            yScaleSetConfig,
            bandScaleConfig,
            legendConfig,
            ...common
        } = this.props;

        return (
            <div>
                {legendConfig.show?
                    <Legend
                        {...common}
                        legendConfig={legendConfig}
                    />
                    : null
                }
                <Chart
                    chartShape={props => (<BarHorizontal {...props}/>)}
                    xScaleSetConfig={xScaleSetConfig}
                    yScaleSetConfig={yScaleSetConfig}
                    customYScaleSetConfig={bandScaleConfig}
                    {...common}
                >
                    {this.props.children}
                </Chart>
            </div>
        )
    }
}
